import { IconButton, Modal, Stack } from "@mui/material";
import { ContentModal } from "../../Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import Questions from "./components/Questions/Questions";
import ChooseInstallation from "./components/ChooseInstallation/ChooseInstallation";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ConfirmationService from "./components/ConfirmationService/ConfirmationService";
import { useHistory } from "react-router-dom";
import ConfirmStove from "./components/ConfirmStove/ConfirmStove";

export default function ModalReconnect({ open, onClose }) {
    const [page, setPage] = useState("questions");
    const [data, setData] = useState(null);
    const [service, setService] = useState(null);
    const [serviceConfirmed, setServiceConfirmed] = useState(false);

    const router = useHistory();

    const handleClose = () => {
        onClose();
        if (serviceConfirmed) {
            router.push("/save-time");
        }
    };

  const handleCloseReconnect = () => {
    onClose();
    router.push("/save-time");
  };

  return (
    <Modal open={open} onClose={handleClose} disableAutoFocus={true}>
      <ContentModal
        minWidth={"675px"}
        style={{ width: "auto" }}
        borderRadius={"8px"}
      >
        <Stack
          direction={"row"}
          justifyContent={
            page !== "questions" && !serviceConfirmed
              ? "space-between"
              : "flex-end"
          }
          alignItems={"center"}
          p={"10px 23px"}
        >
          {page !== "questions" && !serviceConfirmed && (
            <IconButton onClick={() => setPage("questions")} sx={{ p: 0 }}>
              <ArrowBackIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          )}

          {page !== "questions" && (
            <IconButton onClick={handleClose}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          )}
        </Stack>
        {page === "questions" && (
          <Questions
            onChangePage={(page, data) => {
              setPage(page);
              setData(data);
            }}
            handleClose={handleClose}
            handleCloseReconnect={handleCloseReconnect}
          />
        )}
        {page === "chooseInstallation" && (
          <ChooseInstallation
            onChangePage={(page, service) => {
              setPage(page);
              setService(service);
            }}
          />
        )}
        {page === "confirmService" && (
          <ConfirmationService
            data={data}
            service={service}
            serviceConfirmed={setServiceConfirmed}
          />
        )}
        {page === "confirmServiceStove" && (
          <ConfirmStove
            service={service}
            data={data}
            onChangePage={(page, service) => {
              setPage(page);
              setService(service);
            }}
          />
        )}
      </ContentModal>
    </Modal>
  );
}
